import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82fec6a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ReportPage"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Correo a @ContesisLa", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "Correo Electronico", -1))
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Mensaje", -1))
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "formFile",
  class: "form-label"
}, "Agregar Archivo", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { Ref,ref } from 'vue'
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportButtom',
  props: {
    CardReport: Boolean,
},
  emits: ['updateProps'],
  setup(__props, { emit: __emit }) {

const dUrl = UrlGlobal()

const props = __props
const emits = __emit
        const handleClick = () =>{
            emits("updateProps",!props.CardReport)
        }


//envio de correo----------------------------------------------------
const email = ref('');
const mensaje = ref('');
const archivo = ref<File | null>(null);

// Función para capturar el archivo subido
const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  archivo.value = target.files ? target.files[0] : null;
};

// Función para enviar el correo
const enviarCorreo = async () => {
  const formData = new FormData();
  formData.append('correo_remitente', email.value);
  formData.append('mensaje', mensaje.value);
  
  if (archivo.value) {
    formData.append('archivo', archivo.value);
  }

  try {
    const response = await fetch(dUrl.urlGlobal +'/api/envio_correo', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.status === 'success') {
      alert('Correo enviado correctamente');
      email.value = '';
      mensaje.value = '';
      archivo.value = null;
    } else {
      alert(`Error: ${data.message}`);
    }
  } catch (error) {
    alert('Ocurrió un error al enviar el correo');
    console.error(error);
  }
};
//-------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.CardReport==true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop",
          onClick: handleClick
        }))
      : _createCommentVNode("", true),
    (props.CardReport==true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              id: "exampleFormControlInput1",
              placeholder: "name@example.com",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              style: {"background-color":"transparent","color":"black"}
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "exampleFormControlTextarea1",
              rows: "3",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mensaje).value = $event)),
              style: {"resize":"vertical","background-color":"transparent","color":"black"}
            }, null, 512), [
              [_vModelText, mensaje.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("input", {
              class: "form-control",
              type: "file",
              id: "formFile",
              onChange: handleFileUpload,
              style: {"background-color":"transparent","color":"black"}
            }, null, 32)
          ]),
          _hoisted_10,
          _createElementVNode("div", { class: "SuccessButoms" }, [
            _createElementVNode("button", { onClick: handleClick }, "cancelar"),
            _createElementVNode("button", {
              onClick: enviarCorreo,
              style: {"background-color":"#001982"}
            }, "enviar")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})